import { BarDatum } from '@nivo/bar';
import {TimeFrameChart} from "../enum/Dashboard.enum";

export interface TransactionData extends BarDatum {
  timePeriod: string
  transactions: number
}

// Naranja del portal (button-primary.500 / primary.800) y tonos de gris (neutral.*),
// en vez del arcoíris original — mismo naranja usado en la gráfica de barras.
export const COLORS = [
  '#F14A1D', '#EEECED', '#FABEAD',
  '#8D8186', '#D6D2D4', '#585053',
  '#F14A1D', '#EEECED', '#FABEAD',
  '#8D8186', '#D6D2D4', '#585053',
];


export interface groupTransactionBarModel {
  key: TimeFrameChart
  groupMap: Map<string|number, number>
  dateRange: {start: Date, end: Date} | null
}

export const DAYS = ["Lunes", "Martes", "Miercoles", "Jueves", "Viernes", "Sabado", "Domingo"]
export const MONTHS = ["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio", "Agosto",
  "Septiembre", "Octubre", "Noviembre", "Diciembre"]

export const dayTranslateMap = new Map(DAYS.map((day, index) => {
  index++
  return [(index === 7 ? 0 : index), day]
}))


export const monthTranslateMap = new Map(MONTHS.map((month, index) => [index , month]))

